import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "app-button-flat__content" }

import { computed, useAttrs } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppButtonFlat',
  props: {
    size: { default: "default" },
    color: { default: "primary" },
    variant: { default: "flat" }
  },
  setup(__props: any) {



const props = __props;

const attrs = useAttrs();

const isLoading = computed(() => Boolean(attrs.loading));
const passthroughDisabled = computed(() => Boolean(attrs.disabled));

const buttonClass = computed(() => [
  "app-button-flat",
  props.size === "small" ? "app-button-flat--small" : null,
  `app-button-flat--${props.color}`,
  props.variant === "outlined" ? "app-button-flat--outlined" : null,
  attrs.class,
]);

const buttonAttrs = computed(() => {
  // Vuetify icon props come through attrs as camelCase (e.g. prependIcon for prepend-icon).
  // When loading, we hide any prepend/append icons so the spinner is the only leading visual.
  const { class: _class, loading, disabled, ...rest } = attrs as Record<string, unknown>;

  if (isLoading.value) {
    delete (rest as any).prependIcon;
    delete (rest as any).appendIcon;
    // Be defensive in case attrs preserve kebab-case in some environments.
    delete (rest as any)["prepend-icon"];
    delete (rest as any)["append-icon"];
  }

  return rest;
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
    class: buttonClass.value,
    color: props.color,
    variant: props.variant,
    disabled: isLoading.value || passthroughDisabled.value
  }, buttonAttrs.value), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              indeterminate: "",
              size: props.size === 'small' ? 16 : 18,
              width: 2,
              class: "app-button-flat__spinner"
            }, null, 8, ["size"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 16, ["class", "color", "variant", "disabled"]))
}
}

})